// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { doc, getDoc, getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
	apiKey: "AIzaSyCbzB0N5Um5nU_0zBtGTm4ZwAo_gjZVBTY",
	authDomain: "speed-dater-77fba.firebaseapp.com",
	projectId: "speed-dater-77fba",
	storageBucket: "speed-dater-77fba.firebasestorage.app",
	messagingSenderId: "763724130079",
	appId: "1:763724130079:web:27dea34e4a0db47832722a",
	measurementId: "G-4V19ETLPCY",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

const getUserData = async (uid) => {
	if (!uid) throw new Error("UID is required to fetch user data.");

	try {
		const userDoc = await getDoc(doc(db, "users", uid));
		if (userDoc.exists()) {
			return userDoc.data(); // Return the user's data
		} else {
			console.warn("No user data found for the provided UID.");
			return {}; // Return an empty object if no data exists
		}
	} catch (error) {
		console.error("Error fetching user data:", error);
		throw error;
	}
};

export { auth, db, getUserData, storage };
